import { render, staticRenderFns } from "./NewArrivals.vue?vue&type=template&id=29a32a2a&scoped=true"
import script from "./NewArrivals.vue?vue&type=script&lang=js"
export * from "./NewArrivals.vue?vue&type=script&lang=js"
import style0 from "./NewArrivals.vue?vue&type=style&index=0&id=29a32a2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a32a2a",
  null
  
)

export default component.exports